import classes from './betKalkulatoriLista.module.css'
import { useEffect, useRef, useState } from 'react'
import { ReactComponent as PlayIcon } from '../assets/icons/play.svg'
import { betkoPopupWithAction } from '../utils/BetkoPopupModal'
import { useLocation, useNavigate } from 'react-router-dom'
import useCommentPopup from '../hooks/useCommentPopup'

const items = [
  {
    title: 'Bet Kalkulatori',
    items: [
      { id: 'bet_kalkulatori', title: 'Uvod U Kalkulatore', type: 'intro' },
    ],
  },
  {
    title: 'Kalkulatori Procene',
    items: [
      {
        id: 'fudbal_-_sve_igre',
        title: 'Fudbal Sve Igre',
        type: 'ready',
        calcType: 'Fudbal - sve igre',
      },
      {
        id: 'tr_procena',
        title: 'Procena Tačnog Rezultata',
        type: 'ready',
        calcType: 'Procena tacnog rezultata',
      },
      {
        id: 'live-interaktiv',
        title: 'Live Interaktiv',
        type: 'ready',
        calcType: 'Live interaktiv',
      },
      {
        id: 'košarka',
        title: 'Košarka',
        type: 'ready',
        calcType: 'Kosarka',
      },
      {
        id: 'košarka_poeni_igrača',
        title: 'Košarka Poeni Igrača',
        type: 'ready',
        calcType: 'Kosarka poeni igraca',
      },
      {
        id: 'hokej',
        title: 'Hokej',
        type: 'ready',
        calcType: 'Hokej',
      },
      {
        id: 'americki-fudbal',
        title: 'Američki Fudbal',
        type: 'ready',
        calcType: 'Americki fudbal',
      },
      {
        id: 'bejzbol',
        title: 'Bejzbol',
        type: 'ready',
        calcType: 'Bejzbol',
      },
      {
        id: 'stoni-tenis',
        title: 'Stoni Tenis',
        type: 'ready',
        calcType: 'Stoni tenis',
      },
      {
        id: 'tenis',
        title: 'Tenis',
        type: 'ready',
        calcType: 'Tenis',
      },
      {
        id: 'vaterpolo',
        title: 'Vaterpolo',
        type: 'ready',
        calcType: 'Vaterpolo',
      },
      {
        id: 'rukomet',
        title: 'Rukomet',
        type: 'ready',
        calcType: 'Rukomet',
      },
      {
        id: 'badminton',
        title: 'Badminton',
        type: 'ready',
        calcType: 'Badminton',
      },
      {
        id: 'odbojka',
        title: 'Odbojka',
        type: 'ready',
        calcType: 'Odbojka',
      },
      {
        id: 'odbojka-plaža',
        title: 'Odbojka Na Pesku',
        type: 'ready',
        calcType: 'Odbojka na pesku',
      },
      {
        id: 'futsal',
        title: 'Futsal',
        type: 'ready',
        calcType: 'Futsal',
      },
      {
        id: 'boks',
        title: 'Boks',
        type: 'ready',
        calcType: 'Boks',
      },
      {
        id: 'mma',
        title: 'Mma',
        type: 'ready',
        calcType: 'Mma',
      },
      {
        id: 'bilijar',
        title: 'Bilijar',
        type: 'ready',
        calcType: 'Bilijar',
      },
      {
        id: 'esports',
        title: 'Esports',
        type: 'ready',
        calcType: 'Esports',
      },
      {
        id: 'pikado',
        title: 'Pikado',
        type: 'ready',
        calcType: 'Pikado',
      },
    ],
  },
  {
    title: 'Kalkulatori Statistike',
    items: [
      {
        id: 'projekcija_ut.',
        title: 'Projekcija Utakmice',
        type: 'ready',
        calcType: 'Projekcija utakmice',
      },
      {
        id: 'statistika_sudija',
        title: 'Statistika Sudija',
        type: 'ready',
        calcType: 'Statistika sudija',
      },
    ],
  },
  {
    title: 'Kalkulatori Kvota',
    items: [
      {
        id: 'nivelacija_kvota',
        title: 'Nivelacija Kvota',
        type: 'ready',
        calcType: 'Nivelacija kvota',
      },
      {
        id: 'procena_vrednosti_tiketa',
        title: 'Procena Vrednosti Tiketa',
        type: 'ready',
        calcType: 'Procena vrednosti tiketa',
      },
      {
        id: 'odbrana-tiketa',
        title: 'Odbrana Tiketa',
        type: 'ready',
        calcType: 'Odbrana tiketa',
      },
    ],
  },
  {
    title: 'Kalkulatori Strategije',
    items: [
      {
        id: 'd_alembert',
        title: 'D Alembert',
        type: 'ready',
        calcType: 'D alembert',
      },
      {
        id: 'paroli',
        title: 'Paroli',
        type: 'ready',
        calcType: 'Paroli',
      },
    ],
  },
  {
    title: 'Kalkulatori Progresije',
    items: [
      {
        id: 'pozitivna_linija',
        title: 'Pozitivna Linija',
        type: 'ready',
        calcType: 'Pozitivna linija',
      },
      {
        id: 'pozitivna-progresija',
        title: 'Pozitivna Progresija',
        type: 'ready',
        calcType: 'Pozitivna progresija',
      },
      {
        id: 'arbitraža',
        title: 'Arbitražni Kalkulator',
        type: 'ready',
        calcType: 'Arbitrazni betko kalkulator',
      },
      {
        id: 'negativna-progresija',
        title: 'Negativna Progresija',
        type: 'ready',
        calcType: 'Negativna progresija',
      },
    ],
  },
  {
    title: 'Kalkulatori Sistema',
    items: [
      {
        id: 'isplative_kvote_i_broj_kombinacija',
        title: 'Isplative Kvote ',
        type: 'ready',
        calcType: 'Isplative kvote i broj kombinacija',
      },
    ],
  },
]

const BetKalkulatori = () => {
  const [isListVisible, setIsListVisible] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()
  const currentCalculatorId = decodeURIComponent(
    window.location.pathname.split('/').filter(Boolean).pop()
  )
  const { fetchAndShowPopup, loading } = useCommentPopup()
  const ref = useRef()

  const toggleListVisibility = () => {
    setIsListVisible((prev) => {
      const newState = !prev
      navigate('/bet_kalkulatori', {
        state: { openList: newState ? 'true' : 'false' },
      })
      return newState
    })
  }

  useEffect(() => {
    if (isListVisible) {
      ref.current?.scrollIntoView()
    }
  }, [isListVisible])

  useEffect(() => {
    if (location.state && location.state.openList === 'true') {
      setIsListVisible(true)
    } else {
      setIsListVisible(false)
    }
  }, [location.state])

  const getButtonClass = (type) => {
    if (type === 'soon') return classes.soonButton
    if (type === 'ready') return classes.readyButton
    return ''
  }

  const handleItemClick = (item, type, id) => {
    if (type === 'soon') {
      betkoPopupWithAction(
        'Kalkulator u izradi',
        `${item.title} će uskoro biti dostupan.`,
        null
      )
    } else if (type === 'ready') {
      navigate(`/bet_kalkulatori/${id}`)
    } else {
      navigate(`/bet_kalkulatori/`)
    }
  }

  const handleButtonClick = (item, type, calcType) => {
    if (type === 'soon') {
      betkoPopupWithAction(
        'Tutorijal u izradi',
        `Tutorijal ${item.title} će uskoro biti dostupan.`
      )
    } else if (type === 'ready') {
      fetchAndShowPopup(calcType)
    }
  }

  return (
    <>
      <div className={classes.toggleButtonContainer}>
        <button onClick={toggleListVisibility} className={classes.toggleButton}>
          {isListVisible
            ? 'Zatvori listu kalkulatora'
            : 'Pogledaj listu kalkulatora'}
        </button>
      </div>
      <div
        className={`${classes.container} ${
          isListVisible ? classes.visible : ''
        }`}
        ref={ref}
      >
        <ul>
          {items.map((item, index) => (
            <div key={index}>
              <li className={classes.liTitle}>
                <div className={classes.itemTitle}>{item.title}</div>
              </li>
              {item.items.map((calculatorItem, calculatorIndex) => (
                <li
                  key={calculatorIndex}
                  className={`${classes.liItem} ${
                    calculatorItem.id === currentCalculatorId
                      ? classes.selected
                      : ''
                  }`}
                  onClick={() =>
                    handleItemClick(
                      calculatorItem,
                      calculatorItem.type,
                      calculatorItem.id
                    )
                  }
                >
                  <div className={classes.itemTitle}>
                    {calculatorItem.title}
                  </div>
                  {calculatorItem.type !== 'intro' && (
                    <button
                      className={getButtonClass(calculatorItem.type)}
                      onClick={(e) => {
                        e.stopPropagation()
                        handleButtonClick(
                          calculatorItem,
                          calculatorItem.type,
                          calculatorItem.calcType
                        )
                      }}
                      disabled={loading}
                    >
                      <PlayIcon className={classes.playIcon} />
                      {calculatorItem.type === 'ready' && 'Tutorial'}
                      {calculatorItem.type === 'soon' && 'Uskoro'}
                    </button>
                  )}
                </li>
              ))}
            </div>
          ))}
        </ul>
      </div>
    </>
  )
}

export default BetKalkulatori
